export const fovOptions = [24, 50, 80];
export const terraBaseOptions = ["tactical", "world"];

export const getBounds = (coords) => {
    const bounds = coords.reduce((acc, curr) => {
        return [
            [Math.min(acc[0][0], curr[0]), Math.min(acc[0][1], curr[1])], // SW [minLng, minLat]
            [Math.max(acc[1][0], curr[0]), Math.max(acc[1][1], curr[1])]  // NE [maxLng, maxLat]
        ];
    }, [[coords[0][0], coords[0][1]], [coords[0][0], coords[0][1]]]);

    return bounds;
}

export const getRectangle = (startPoint, endPoint) => {
    const rectanglePoints = [
        [startPoint[0], startPoint[1]],
        [startPoint[0], endPoint[1]],
        [endPoint[0], endPoint[1]],
        [endPoint[0], startPoint[1]],
    ];

    return rectanglePoints
}